'use strict';
import template from './soportePCD.html';
import controller from './soportePCD.controller';

const SoportePCDComponent = {
  controller,
  template
};

export default SoportePCDComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/soportePCD/soportePCD.component.js